import { render, staticRenderFns } from "./UsersPrivilegeRevenus.vue?vue&type=template&id=f64f6bec&scoped=true&"
import script from "./UsersPrivilegeRevenus.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeRevenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64f6bec",
  null
  
)

export default component.exports